module.exports = __webpack_public_path__ + "img/Support-skill-432.ce1ee047.png";